// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scanner-card {
    background: white;
    border: 1px solid #e1e4e8;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    overflow: hidden;
    transition: all 0.2s ease;
}

.scanner-card:hover {
    border-color: #c8cdd3;
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.12);
}

.scanner-card-header {
    padding: 14px 16px;
    border-bottom: 1px solid #e1e4e8;
    background: #f6f8fa;
}

.scanner-header-content {
    display: flex;
    align-items: center;
    gap: 12px;
}

.scanner-card-header h3 {
    margin: 0;
    color: #1a1a1a;
    font-size: 15px;
    font-weight: 600;
    flex: 1 1;
}

.status-badge {
    padding: 3px 10px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.3px;
}

.status-badge.connected {
    background: #d4edda;
    color: #155724;
}

.status-badge.disconnected {
    background: #f8d7da;
    color: #721c24;
}

.scanner-card-body {
    padding: 14px 16px;
    display: grid;
    gap: 10px;
}

.info-row {
    display: grid;
    grid-template-columns: 140px 1fr;
    gap: 12px;
    align-items: start;
}

.info-row.key-row {
    align-items: center;
}

.info-row .label {
    font-size: 11px;
    color: #666;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    padding-top: 2px;
}

.info-row .value {
    color: #1a1a1a;
    font-size: 13px;
    line-height: 1.5;
}

.info-row-dual {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
}

.info-col {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.info-col .label {
    font-size: 11px;
    color: #666;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.info-col .value {
    color: #1a1a1a;
    font-size: 13px;
    line-height: 1.5;
}

.security-metrics {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
    margin-top: 8px;
}

.metric {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
}

.metric-label {
    font-size: 9px;
    color: #666;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    text-align: center;
}

.metric-value {
    font-size: 16px;
    font-weight: 700;
    color: #1a1a1a;
    text-align: center;
}

.key-container {
    display: flex;
    align-items: center;
    gap: 8px;
}

.scanner-key {
    background: #f6f8fa;
    padding: 6px 10px;
    border-radius: 4px;
    border: 1px solid #e1e4e8;
    font-family: 'Roboto Mono', 'Consolas', monospace;
    font-size: 12px;
    color: #24292e;
    flex: 1 1;
    letter-spacing: 0.5px;
}

.toggle-key-btn {
    background: transparent;
    border: 1px solid #e1e4e8;
    padding: 4px 8px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
}

.toggle-key-btn:hover {
    background: #f6f8fa;
    border-color: #c8cdd3;
}

.truncate {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.scanner-card-footer {
    padding: 12px 16px;
    background: #f6f8fa;
    border-top: 1px solid #e1e4e8;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.config-btn {
    width: 100%;
    padding: 8px 14px;
    background: #0366d6;
    color: white;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-size: 13px;
    font-weight: 600;
    transition: all 0.2s;
}

.config-btn:hover {
    background: #0256c2;
}

.test-webhook-buttons {
    display: flex;
    gap: 6px;
}

.test-btn {
    flex: 1 1;
    padding: 7px 12px;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    transition: all 0.2s;
}

.test-btn.test-ok {
    background: #28a745;
    color: white;
}

.test-btn.test-ok:hover {
    background: #218838;
}

.test-btn.test-nok {
    background: #dc3545;
    color: white;
}

.test-btn.test-nok:hover {
    background: #c82333;
}

.users-list {
    font-size: 12px;
}

.key-button-container {
    display: flex;
    align-items: center;
    gap: 8px;
}

.key-icon {
    font-size: 18px;
}

.show-key-btn {
    background: #f6f8fa;
    border: 1px solid #e1e4e8;
    padding: 8px 12px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 13px;
    font-weight: 600;
    color: #1a1a1a;
    transition: all 0.2s;
    flex: 1 1;
}

.show-key-btn:hover {
    background: #e1e4e8;
    border-color: #c8cdd3;
}

/* Key Modal */
.key-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.key-modal {
    background: white;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
    width: 90%;
    max-width: 500px;
    overflow: hidden;
}

.key-modal-header {
    padding: 16px 20px;
    border-bottom: 1px solid #e1e4e8;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #f6f8fa;
}

.key-modal-header h4 {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: #1a1a1a;
}

.key-modal-close {
    background: transparent;
    border: none;
    font-size: 28px;
    line-height: 1;
    cursor: pointer;
    color: #666;
    padding: 0;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: color 0.2s;
}

.key-modal-close:hover {
    color: #1a1a1a;
}

.key-modal-body {
    padding: 20px;
}

.key-display {
    background: #f6f8fa;
    border: 1px solid #e1e4e8;
    border-radius: 6px;
    padding: 16px;
    margin-bottom: 16px;
    word-break: break-all;
}

.key-display code {
    font-family: 'Roboto Mono', 'Consolas', monospace;
    font-size: 14px;
    color: #24292e;
    letter-spacing: 0.5px;
}

.copy-key-btn {
    width: 100%;
    padding: 10px 16px;
    background: #0366d6;
    color: white;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}

.copy-key-btn:hover {
    background: #0256c2;
}

.copy-key-btn.copied {
    background: #28a745;
}

.copy-key-btn.copied:hover {
    background: #218838;
}
`, "",{"version":3,"sources":["webpack://./src/components/ScannerCard.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,yCAAyC;IACzC,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,SAAS;IACT,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,SAAO;AACX;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,iDAAiD;IACjD,eAAe;IACf,cAAc;IACd,SAAO;IACP,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,6BAA6B;IAC7B,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,SAAO;IACP,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,SAAO;AACX;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA,cAAc;AACd;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,yCAAyC;IACzC,UAAU;IACV,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,eAAe;IACf,WAAW;IACX,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,iDAAiD;IACjD,eAAe;IACf,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".scanner-card {\n    background: white;\n    border: 1px solid #e1e4e8;\n    border-radius: 8px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n    overflow: hidden;\n    transition: all 0.2s ease;\n}\n\n.scanner-card:hover {\n    border-color: #c8cdd3;\n    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.12);\n}\n\n.scanner-card-header {\n    padding: 14px 16px;\n    border-bottom: 1px solid #e1e4e8;\n    background: #f6f8fa;\n}\n\n.scanner-header-content {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.scanner-card-header h3 {\n    margin: 0;\n    color: #1a1a1a;\n    font-size: 15px;\n    font-weight: 600;\n    flex: 1;\n}\n\n.status-badge {\n    padding: 3px 10px;\n    border-radius: 12px;\n    font-size: 11px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.3px;\n}\n\n.status-badge.connected {\n    background: #d4edda;\n    color: #155724;\n}\n\n.status-badge.disconnected {\n    background: #f8d7da;\n    color: #721c24;\n}\n\n.scanner-card-body {\n    padding: 14px 16px;\n    display: grid;\n    gap: 10px;\n}\n\n.info-row {\n    display: grid;\n    grid-template-columns: 140px 1fr;\n    gap: 12px;\n    align-items: start;\n}\n\n.info-row.key-row {\n    align-items: center;\n}\n\n.info-row .label {\n    font-size: 11px;\n    color: #666;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    padding-top: 2px;\n}\n\n.info-row .value {\n    color: #1a1a1a;\n    font-size: 13px;\n    line-height: 1.5;\n}\n\n.info-row-dual {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 16px;\n}\n\n.info-col {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.info-col .label {\n    font-size: 11px;\n    color: #666;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.info-col .value {\n    color: #1a1a1a;\n    font-size: 13px;\n    line-height: 1.5;\n}\n\n.security-metrics {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 8px;\n    margin-top: 8px;\n}\n\n.metric {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 4px;\n}\n\n.metric-label {\n    font-size: 9px;\n    color: #666;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.3px;\n    text-align: center;\n}\n\n.metric-value {\n    font-size: 16px;\n    font-weight: 700;\n    color: #1a1a1a;\n    text-align: center;\n}\n\n.key-container {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.scanner-key {\n    background: #f6f8fa;\n    padding: 6px 10px;\n    border-radius: 4px;\n    border: 1px solid #e1e4e8;\n    font-family: 'Roboto Mono', 'Consolas', monospace;\n    font-size: 12px;\n    color: #24292e;\n    flex: 1;\n    letter-spacing: 0.5px;\n}\n\n.toggle-key-btn {\n    background: transparent;\n    border: 1px solid #e1e4e8;\n    padding: 4px 8px;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 14px;\n    transition: all 0.2s;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.toggle-key-btn:hover {\n    background: #f6f8fa;\n    border-color: #c8cdd3;\n}\n\n.truncate {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.scanner-card-footer {\n    padding: 12px 16px;\n    background: #f6f8fa;\n    border-top: 1px solid #e1e4e8;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.config-btn {\n    width: 100%;\n    padding: 8px 14px;\n    background: #0366d6;\n    color: white;\n    border: none;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: 13px;\n    font-weight: 600;\n    transition: all 0.2s;\n}\n\n.config-btn:hover {\n    background: #0256c2;\n}\n\n.test-webhook-buttons {\n    display: flex;\n    gap: 6px;\n}\n\n.test-btn {\n    flex: 1;\n    padding: 7px 12px;\n    border: none;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: 12px;\n    font-weight: 600;\n    transition: all 0.2s;\n}\n\n.test-btn.test-ok {\n    background: #28a745;\n    color: white;\n}\n\n.test-btn.test-ok:hover {\n    background: #218838;\n}\n\n.test-btn.test-nok {\n    background: #dc3545;\n    color: white;\n}\n\n.test-btn.test-nok:hover {\n    background: #c82333;\n}\n\n.users-list {\n    font-size: 12px;\n}\n\n.key-button-container {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.key-icon {\n    font-size: 18px;\n}\n\n.show-key-btn {\n    background: #f6f8fa;\n    border: 1px solid #e1e4e8;\n    padding: 8px 12px;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: 13px;\n    font-weight: 600;\n    color: #1a1a1a;\n    transition: all 0.2s;\n    flex: 1;\n}\n\n.show-key-btn:hover {\n    background: #e1e4e8;\n    border-color: #c8cdd3;\n}\n\n/* Key Modal */\n.key-modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n}\n\n.key-modal {\n    background: white;\n    border-radius: 8px;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);\n    width: 90%;\n    max-width: 500px;\n    overflow: hidden;\n}\n\n.key-modal-header {\n    padding: 16px 20px;\n    border-bottom: 1px solid #e1e4e8;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background: #f6f8fa;\n}\n\n.key-modal-header h4 {\n    margin: 0;\n    font-size: 16px;\n    font-weight: 600;\n    color: #1a1a1a;\n}\n\n.key-modal-close {\n    background: transparent;\n    border: none;\n    font-size: 28px;\n    line-height: 1;\n    cursor: pointer;\n    color: #666;\n    padding: 0;\n    width: 30px;\n    height: 30px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: color 0.2s;\n}\n\n.key-modal-close:hover {\n    color: #1a1a1a;\n}\n\n.key-modal-body {\n    padding: 20px;\n}\n\n.key-display {\n    background: #f6f8fa;\n    border: 1px solid #e1e4e8;\n    border-radius: 6px;\n    padding: 16px;\n    margin-bottom: 16px;\n    word-break: break-all;\n}\n\n.key-display code {\n    font-family: 'Roboto Mono', 'Consolas', monospace;\n    font-size: 14px;\n    color: #24292e;\n    letter-spacing: 0.5px;\n}\n\n.copy-key-btn {\n    width: 100%;\n    padding: 10px 16px;\n    background: #0366d6;\n    color: white;\n    border: none;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 600;\n    transition: all 0.2s;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n}\n\n.copy-key-btn:hover {\n    background: #0256c2;\n}\n\n.copy-key-btn.copied {\n    background: #28a745;\n}\n\n.copy-key-btn.copied:hover {\n    background: #218838;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
